/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_AddInputs */

const en_us2_body_measures_add = /** @type {(inputs: Body_Measures_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log a measurement`)
};

const pt_br2_body_measures_add = /** @type {(inputs: Body_Measures_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar medida`)
};

const es_419_body_measures_add = /** @type {(inputs: Body_Measures_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar medida`)
};

const pt_pt2_body_measures_add = /** @type {(inputs: Body_Measures_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registar medida`)
};

const fr_fr2_body_measures_add = /** @type {(inputs: Body_Measures_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noter une mesure`)
};

const de_de2_body_measures_add = /** @type {(inputs: Body_Measures_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfang eintragen`)
};

const it_it2_body_measures_add = /** @type {(inputs: Body_Measures_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra misura`)
};

/**
* | output |
* | --- |
* | "Log a measurement" |
*
* @param {Body_Measures_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_add = /** @type {((inputs?: Body_Measures_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_add(inputs)
	if (locale === "es-419") return es_419_body_measures_add(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_add(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_add(inputs)
	if (locale === "de-DE") return de_de2_body_measures_add(inputs)
	if (locale === "it-IT") return it_it2_body_measures_add(inputs)
	return en_us2_body_measures_add(inputs)
});
export { body_measures_add as "body-measures.add" }